import React, { useState, useRef, useEffect } from 'react';

export interface ThreeDotMenuItem {
  label: string;
  onClick: () => void;
  variant?: 'default' | 'danger';
  hide?: boolean;
}

export interface ThreeDotMenuProps {
  items: ThreeDotMenuItem[];
  className?: string;
  disabled?: boolean;
}

const ThreeDotMenu: React.FC<ThreeDotMenuProps> = ({ items, className, disabled = false }) => {
  const menuRef = useRef<HTMLDivElement | null>(null);
  const [isMenuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };

    if (isMenuOpen) document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen, setMenuOpen]);

  const handleMenuToggle = (e) => {
    e.preventDefault();
    if (!disabled) setMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <div className={`three-dot-menu ${className} ${!disabled ? 'three-dot-active' : ''}`} onClick={handleMenuToggle}>
        <img
          className={`${disabled ? 'three-dot-disabled-filter' : ''}`}
          src="assets/icons/icon-three-dots-black.svg"
        />
        <div
          className={`three-dot-menu__menu-options ${isMenuOpen ? 'three-dot-menu__menu-options__visible' : ''}`}
          ref={menuRef}>
          {items
            .filter((x) => !x.hide)
            .map((x) => {
              return (
                <React.Fragment key={x.label}>
                  {x.variant === 'danger' && (
                    <div className="three-dot-menu__menu-options__menu-option__separator"></div>
                  )}
                  <div
                    key={x.label}
                    className={`three-dot-menu__menu-options__menu-option ${x.variant === 'danger' ? 'menu-option-danger' : ''}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      x.onClick();
                      setMenuOpen(false);
                    }}>
                    {x.label}
                  </div>
                </React.Fragment>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default ThreeDotMenu;
